import React, { useEffect } from 'react'
import { Col } from 'react-bootstrap'
import ChatPreview from './Preview/MessageCenterChatPreview.component'
import ChatSidePanel from './SidePanel/MessageCenterChatSidePanel.component'
import './MessageCenterChatStyle.css'
import useChat from './useChat'
import { AddChatModal } from '@components/layout/Modals'
import MessageCenterDeleteConversationModal from '../MessageCenterDeleteConversationModal.component'
import { Button } from '@components/common'
import { EmptyState } from '@components/ui'
import { useMessageCenterTabLayer } from '../MessageCenterTabLayer.context'
import { useAppSelector } from '@store/hooks'

function MessageCenterChat(): React.ReactElement {
  const chatHooks = useChat()
  const { setTabLayerActions } = useMessageCenterTabLayer()
  const conversations = useAppSelector((state) => state.chat.data) ?? []
  const chatLoading = useAppSelector((state) => state.chat.loading)
  const hasNoChats = !chatLoading && conversations.length === 0
  const showFullEmptyState = hasNoChats
  const showPaneEmptyState = !showFullEmptyState && !chatHooks.selectedMessage

  useEffect(() => {
    setTabLayerActions(
      <Button
        size="md"
        className="button-primary add-contact-button"
        onClick={() => {
          chatHooks.setShowStartChat(true)
        }}
        disabled={showFullEmptyState}
      >
        New chat
      </Button>,
    )
    return () => setTabLayerActions(null)
  }, [setTabLayerActions, chatHooks.setShowStartChat, showFullEmptyState])

  return (
    <>
      <div className={`mc-chat${showFullEmptyState ? ' mc-chat--empty' : ''}`}>
        {showFullEmptyState ? (
          <EmptyState
            className="mc-chat-empty"
            iconClass="mgc mgc_message_4_fill"
            title="No chats found"
            description="You don't have any conversations on record yet."
            actionLabel="New chat"
            onAction={() => {
              chatHooks.setShowStartChat(true)
            }}
          />
        ) : (
          <>
            <Col md="auto" className="filter-col">
              <ChatSidePanel />
            </Col>
            <Col className="chat-col position-relative">
              {chatHooks.selectedMessage ? (
                <ChatPreview />
              ) : showPaneEmptyState ? (
                <EmptyState
                  className="mc-chat-pane-empty"
                  iconClass="mgc mgc_message_4_fill"
                  title="No conversation selected"
                  description="Select a conversation or start a new chat."
                  actionLabel="New chat"
                  onAction={() => {
                    chatHooks.setShowStartChat(true)
                  }}
                />
              ) : null}
            </Col>
          </>
        )}
      </div>
      <MessageCenterDeleteConversationModal
        show={chatHooks.showModal}
        onCancel={chatHooks.onDeleteModalHide}
        onDelete={chatHooks.onConfirmDeleteChat}
      />
      <AddChatModal
        show={chatHooks.showStartChat}
        setShow={chatHooks.setShowStartChat}
      />
    </>
  )
}

export default MessageCenterChat
